import moment from 'moment';
import { type Reducer } from 'redux';
import { errors } from 'redux-rest-reducer';

import { ACTIONS as classDetilsActions } from '@~/actions/class-status';
import { ACTIONS as homeDetailsActions } from '@~/actions/home-details';
import { ACTIONS as logoutActions } from '@~/actions/logout';
import { type HomeDetailsData } from '@~/type-props/home-details';
import { type ClassStatusState } from '@~/types/models';

const initialState: ClassStatusState = {};

type TClassStatusReducer = Reducer<
  ClassStatusState,
  | {
      type: typeof classDetilsActions.GET_SUCCESS;
      payload: {
        value: {
          class_status: ClassStatusState;
          teacher?: { first_name: string };
        };
      };
    }
  | {
      type: typeof homeDetailsActions.GET_SUCCESS;
      payload: {
        value: HomeDetailsData;
      };
    }
>;

const classStatusReducer: TClassStatusReducer = (
  state = initialState,
  { type, payload },
) => {
  if (type === classDetilsActions.GET_SUCCESS) {
    const {
      value: { class_status: classStatus, teacher },
    } = payload;
    const { next_class_in: nextClassIn, elapsed_time: elapsedTime } = classStatus || {};

    return {
      ...state,
      ...classStatus,
      can_join: classStatus.can_join || undefined,
      ...teacher,
      nextClassTime:
        nextClassIn && nextClassIn > 0
          ? moment().add(nextClassIn, 'seconds').toDate()
          : undefined,
      classStartedTime:
        elapsedTime && elapsedTime > 0
          ? moment().subtract(elapsedTime, 'seconds').toDate()
          : undefined,
      first_name: '',
      classHomeLoadedAtleastOnce: true,
    };
  }

  if (type === homeDetailsActions.GET_SUCCESS) {
    const {
      value: { student, extra_fields: extraFields },
    } = payload;
    const { name: studentName } = student || {};

    return {
      ...state,
      ...extraFields,
      ...student,
      student_name: studentName,
    };
  }

  if (type === logoutActions.POST_SUCCESS || type === errors[401]) {
    return initialState;
  }

  return state;
};

export default classStatusReducer;
